import React from 'react';

interface YouTubePlayerProps {
  embedCode: string;
  className?: string;
}

export const YouTubePlayer: React.FC<YouTubePlayerProps> = ({ 
  embedCode, 
  className = ""
}) => {
  // Extrair apenas o src do iframe embed
  const getSrcFromEmbed = (embed: string): string | null => {
    const srcMatch = embed.match(/src=["'](.*?)["']/);
    return srcMatch ? srcMatch[1] : null;
  };

  const srcUrl = getSrcFromEmbed(embedCode);

  if (!srcUrl) {
    return (
      <div className={`flex items-center justify-center bg-gray-800 text-white rounded-lg ${className}`} style={{ aspectRatio: '16/9' }}>
        <p>Código de embed inválido</p>
      </div>
    );
  }

  return (
    <div className={`relative w-full ${className}`}>
      <div className="relative w-full" style={{ paddingBottom: '56.25%' /* 16:9 */ }}>
        <iframe
          className="absolute top-0 left-0 w-full h-full rounded-lg"
          src={srcUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
}; 